import React, { useEffect, useState } from "react";
import "./ProductSinglePage.scss";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getProductById,
  getAllProducts,
  getAllProductsStatus,
} from "../../store/productSlice"; // Utilisation de getProductById
import { STATUS } from "../../utils/status";
import Loader from "../../components/Loader/Loader";
import { formatPrice } from "../../utils/helpers";
import {
  addToCartAsync,
  getCartMessageStatus,
  setCartMessageOff,
  setCartMessageOn,
} from "../../store/cartSlice";
import {
  addTofavorite,
  getfavoriteMessageStatus,
  setfavoriteMessageOff,
  setfavoriteMessageOn,
} from "../../store/favoriteSlice";

import CartMessage from "../../components/CartMessage/CartMessage";
import FavoriteMessage from "../../components/FavoriteMessage/FavoriteMessage";
import Footer1 from "../../components/Footer/Footer1";
import { IMAGE_URL1 } from "../../utils/apiURL";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { selectUser } from "../../store/authSlice"; // Assurez-vous que le chemin est correct

const ProductSinglePages = () => {
  const { id } = useParams(); // Récupère l'ID du produit depuis l'URL
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState("");
  const cartMessageStatus = useSelector(getCartMessageStatus);
  const favoriteMessageStatus = useSelector(getfavoriteMessageStatus);
  const user = useSelector(selectUser); // Récupère l'utilisateur connecté
  const token = localStorage.getItem("token");

  // Récupère tous les produits du store Redux
  const products = useSelector(getAllProducts);

  // Utilise la fonction getProductById pour obtenir le produit par ID
  const product = getProductById({ product: { products } }, id);

  const productSingleStatus = product ? STATUS.SUCCEEDED : STATUS.FAILED; // Si le produit existe, le statut est SUCCEEDED, sinon FAILED

  useEffect(() => {}, [token]);

  // Quand l'ID change, on récupère le produit correspondant
  useEffect(() => {
    if (!product) {
      // Si le produit n'est pas dans le store, on peut ajouter une logique pour le charger, par exemple, un fetch ici.
    }
  }, [id, product]);

  // Si produit est trouvé, on met à jour l'image sélectionnée
  useEffect(() => {
    if (product && product.product_images1) {
      setSelectedImage(product.product_images1);
    }
  }, [product]);

  if (productSingleStatus === STATUS.FAILED) {
    return <div>Produit non trouvé</div>;
  }

  if (productSingleStatus === STATUS.LOADING) {
    return <Loader />;
  }

  // Fonction pour augmenter la quantité
  const increaseQty = () => {
    setQuantity((prevQty) => {
      let tempQty = prevQty + 1;
      if (tempQty > product.stock) tempQty = product.stock;
      return tempQty;
    });
  };

  // Fonction pour diminuer la quantité
  const decreaseQty = () => {
    setQuantity((prevQty) => {
      let tempQty = prevQty - 1;
      if (tempQty < 1) tempQty = 1;
      return tempQty;
    });
  };

  // Fonction pour ajouter au panier
  const addToCartHandler = (product_id, quantity) => {
    if (!user) {
      toast.error("You must be logged in to add products to the cart.");
      return;
    }

    // Passer le token dans l'action
    dispatch(addToCartAsync({ product_id, quantity, token }))
      .unwrap()
      .then(() => {
        toast.success("Product Added Successfully !");
        dispatch(setCartMessageOn(true));
      })
      .catch((error) => {
        toast.error("Error adding to cart.");
      });
  };

  // Fonction pour ajouter aux favoris
  const addToFavoriteHandler = (product) => {
    let discountedPrice =
      product.price - product.price * (product?.discountPercentage / 100);
    let totalPrice = quantity * discountedPrice;

    dispatch(
      addTofavorite({ ...product, quantity, totalPrice, discountedPrice })
    );
    dispatch(setfavoriteMessageOn(true));
  };

  const handleThumbnailClick = (image) => {
    setSelectedImage(image);
  };

  return (
    <main className="py-5 bg-whitesmoke">
      <ToastContainer className="custom-toast" />
      <div className="product-single">
        <div className="container">
          <div className="product-single-content bg-white grid">
            <div className="product-single-l">
              <div className="product-img">
                <img
                  src={selectedImage ? IMAGE_URL1 + selectedImage : ""}
                  alt="Product"
                  className="img-cover"
                />
                <div className="product-img-thumbs flex">
                  {[
                    "product_images1",
                    "product_images2",
                    "product_images3",
                  ].map((imgKey) =>
                    product?.[imgKey] ? (
                      <div
                        key={imgKey}
                        className="thumb-item"
                        onClick={() => handleThumbnailClick(product[imgKey])}
                      >
                        <img
                          src={IMAGE_URL1 + product[imgKey]}
                          alt="Thumbnail"
                          className="img-cover"
                        />
                      </div>
                    ) : null
                  )}
                </div>
              </div>
            </div>

            <div className="product-single-r">
              <div className="product-details font-manrope">
                <div className="title fs-20 fw-5">{product?.product_name}</div>

                <div className="price">
                  <div className="flex align-center my-1">
                    <div className="new-price fw-5 font-poppins fs-24 text-orange">
                      {formatPrice(product?.price)}
                    </div>
                  </div>
                </div>

                <div className="qty flex align-center my-4">
                  <div className="qty-text">Quantity:</div>
                  <div className="qty-change flex align-center mx-3">
                    <button
                      type="button"
                      className="qty-decrease flex align-center justify-center"
                      onClick={decreaseQty}
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                    <div className="qty-value flex align-center justify-center">
                      {quantity}
                    </div>
                    <button
                      type="button"
                      className="qty-increase flex align-center justify-center"
                      onClick={increaseQty}
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                  </div>
                  {product?.stock < 1 && (
                    <div className="qty-error text-uppercase bg-danger text-white fs-12 ls-1 mx-2 fw-5">
                      out of stock
                    </div>
                  )}
                </div>
                <div className="info flex align-center flex-wrap fs-14">
                  <div className="brand">
                    <span className="text-orange fw-5">Category:</span>
                    <span className="mx-1 text-capitalize">
                      {product?.categories_name}
                    </span>
                  </div>
                  | &nbsp;
                  <div className="brand">
                    <span className="text-orange fw-5">Remaining stock:</span>
                    <span className="mx-1 text-capitalize">
                      {product?.stock}
                    </span>
                  </div>
                </div>
                <div className="btns">
                  <button
                    type="button"
                    className="add-to-cart-btn btn"
                    onClick={() => {
                      if (product?.stock > 0) {
                        // Passer les arguments directement
                        addToCartHandler(product.id, quantity);
                      }
                    }}
                    disabled={product?.stock < 1}
                  >
                    <i className="fas fa-shopping-cart"></i>
                    <span className="btn-text mx-2">add to cart</span>
                  </button>
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="add-to-cart-btn btn"
                    onClick={() => addToFavoriteHandler(product)}
                  >
                    <i className="fa-solid fa-heart"></i>
                    <span className="btn-text mx-0"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="product-description">
            <h2>Product Description</h2>
            <p className="para fw-3 fs-15">{product?.product_description}</p>
          </div>
        </div>
      </div>

      {cartMessageStatus && <CartMessage />}
      {favoriteMessageStatus && <FavoriteMessage />}
      {/* <Footer1 /> */}
    </main>
  );
};

export default ProductSinglePages;
